/**
 * Validates the password for the needed complexity
 * @param value
 * @returns undefined if valid or a string with the error message
 */
export function passwordValidation(value: string | undefined): string | undefined {
	if (!value) {
		return 'No password has been provided.';
	}
	const passwordRegex =
		/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[~!@#$%^&*()_+\-={}|:"<>?[\]\\;',./]).{6,50}$/;
	if (passwordRegex.test(value)) {
		return undefined;
	}
	return `The provided password does not meet the complexity requirements.`;
}
